<template>
  <div class="d-flex justify-content-between">
    <div class="table-responsive flex-shrink-1 mr-3">
      <a-table
        :columns="ratesColumns"
        :data-source="rateCardDataSource"
        :bordered="true"
        :row-key="(rec, idx) => idx"
        size="small"
        :pagination="false"
        :scroll="{ x: true }"
      >
      </a-table>
    </div>
    <div class="table-responsive flex-shrink-1 ml-3">
      <a-table
        :columns="addRateColumns"
        :data-source="additionalRateSource"
        :bordered="true"
        size="small"
        :row-key="(rec, idx) => idx"
        :pagination="false"
      >
      </a-table>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, reactive } from 'vue'
import { IZoneRate } from '@/types/interfaces/IZoneRate'

const ratesColumns = [
  {
    title: 'From (kg)',
    dataIndex: 'minw',
    key: 'minw',
  },
  {
    title: 'Upto (kg)',
    dataIndex: 'maxw',
    key: 'maxw',
  },
  {
    title: 'Cost (INR)',
    dataIndex: 'cost',
    key: 'cost',
  },
]

const addRateColumns = [
  {
    title: 'Additional Weight (kg)',
    dataIndex: 'weight',
    key: 'weight',
  },
  {
    title: 'Cost',
    dataIndex: 'cost',
    key: 'cost',
  },
]

export default defineComponent({
  name: 'RateCardTable',
  props: {
    zoneRate: {
      type: Object as PropType<IZoneRate | null>,
      required: true,
    },
  },
  setup(props) {
    // const store = useStore()
    const rateCardDataSource = computed(() => props.zoneRate?.rateCard)
    const additionalRateSource = computed(() => [props.zoneRate?.additionalRate])
    const rateCardTableRecords = computed(() => rateCardDataSource.value?.length || 0)
    const showTotal = (total: number, range: Array<any>) => {
      return `${range[0]}-${range[1]} of ${total} items`
    }
    const handleViewClick = (record: any) => {
      console.log('Rec: ', record)
    }

    const rateCardPagination = reactive({
      position: 'bottom',
      showSizeChanger: true,
      showQuickJumper: false,
      total: rateCardTableRecords.value || 0,
      simple: false,
      pageSize: 10,
      showTotal: showTotal,
    })

    return {
      ratesColumns,
      rateCardPagination,
      rateCardDataSource,
      additionalRateSource,
      addRateColumns,
      handleViewClick,
    }
  },
})
</script>

<style lang="scss">
.ant-pagination-item,
.ant-pagination-jump-next,
.ant-pagination-jump-prev {
  display: none !important;
}
tr.ant-table-expanded-row,
tr.ant-table-expanded-row:hover {
  background: #f0f2f40d !important;
}
</style>
